<res-base-modal [modalTitle]="'Advanced Search'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'OK'" (primaryButtonActionEmt)="ok()" [isPrimaryBtnEnabled]="okEnabled()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [verifyRequiredValidator]="true" [modalHelpIndex]="modalHelpIndex"
    [modalDraggable]=false [buttonTemplate]="buttonTemplate">

    <div class="advanced-search">
        <div class="advanced-search-content" id="searchPanel">
            <div class="top">
                <div class="top-left-content">
                    <div class="left-top">
                        <div class="search-input-row">
                            <div class="search-input-row-label">
                                <p class="input-indicator">
                                    <span class="any-indicator">ANY</span>
                                    <span class="word-indicator"> of these words:</span>
                                </p>
                            </div>
                            <res-custom-input [field]="searchObject.oneOrMoreWords" [isFieldDisabled]="isInFreeFormMode"
                                [queryFocusChanged]="queryFocusChanged.bind(this)"
                                [automationId]="modalAutomationId + '-one-or-more-words'"></res-custom-input>
                        </div>
                        <div class="search-input-row">
                            <div class="search-input-row-label">
                                <p class="input-indicator">
                                    <span class="all-indicator">ALL</span>
                                    <span class="word-indicator"> of these words:</span>
                                </p>
                            </div>
                            <res-custom-input [field]="searchObject.allWords" [isFieldDisabled]="isInFreeFormMode"
                                [queryFocusChanged]="queryFocusChanged.bind(this)"
                                [automationId]="modalAutomationId + '-all-words'"></res-custom-input>
                        </div>
                        <div class="search-input-row">
                            <div class="search-input-row-label">
                                <p class="input-indicator">
                                    <span class="word-indicator">This exact</span>
                                    <span class="phrase-indicator"> phrase:</span>
                                </p>
                            </div>
                            <res-custom-input [field]="searchObject.exactPhrase" [isFieldDisabled]="isInFreeFormMode"
                                [queryFocusChanged]="queryFocusChanged.bind(this)"
                                [automationId]="modalAutomationId + '-exact-phrase'"></res-custom-input>
                        </div>
                        <div class="search-input-row">
                            <div class="search-input-row-label">
                                <p class="input-indicator">
                                    <span class="none-indicator">NONE</span>
                                    <span class="word-indicator"> of these words:</span>
                                </p>
                            </div>
                            <res-custom-input [field]="searchObject.noneWords" [isFieldDisabled]="isInFreeFormMode"
                                [queryFocusChanged]="queryFocusChanged.bind(this)"
                                [automationId]="modalAutomationId + '-none-words'"></res-custom-input>
                        </div>
                    </div>
                    <div class="left-top-proximity">
                        <div class="search-input-row">
                            <div class="search-input-row-label">
                                <p class="input-indicator">
                                    <span class="any-indicator">ANY</span>
                                    <span class="word-indicator"> of these words:</span>
                                </p>
                            </div>
                            <res-custom-input [field]="searchObject.anyWords" [isFieldDisabled]="isInFreeFormMode"
                                [queryFocusChanged]="queryFocusChanged.bind(this)"
                                [automationId]="modalAutomationId + '-any-words'"></res-custom-input>
                        </div>
                        <div class="search-input-row">
                            <div class="search-input-row-label">
                                <p class="input-indicator"></p>
                            </div>
                            <div class="inline-column">
                                <span class="word-indicator spacer">within:</span>
                                <input class='custom-width-38' type="number" maxLength="3" [disabled]="isInFreeFormMode"
                                    oninput="this.value=this.value.slice(0,this.maxLength)"
                                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                                    min="1" max="999" [(ngModel)]="searchObject.withinProximity"
                                    (ngModelChange)="queryFocusChanged()"
                                    [attr.data-automation-id]="modalAutomationId + '-within-proximity-input'" />
                            </div>
                        </div>
                        <div class="search-input-row">
                            <div class="search-input-row-label">
                                <p class="input-indicator">
                                    <span class="word-indicator">of </span>
                                    <span class="any-indicator">ANY</span>
                                    <span class="word-indicator"> of these words:</span>
                                </p>
                            </div>
                            <res-custom-input [field]="searchObject.anyDistanceWords"
                                [isFieldDisabled]="isInFreeFormMode" [queryFocusChanged]="queryFocusChanged.bind(this)"
                                [automationId]="modalAutomationId + '-any-distance-words'"></res-custom-input>
                        </div>
                    </div>
                </div>
                <div class="right-top-content">
                    <div class="date-range-picker">
                        <span class="range-indicator" [ngClass]="{ disabled: isInFreeFormMode}">Date Range:</span>
                        <res-custom-date-time-picker class="date-time-picker" name="dateStart" ngDefaultControl
                            [inputPlaceholder]="defaultDatePlaceholders[0]" (click)="onDateClick($event,'start')"
                            (focusout)="onFocusLost($event,'start');" [(ngModel)]="searchObject.startDate"
                            [isDateRange]="true" [hasErrorMessage]="dateError" [isStart]="true" [isEnd]="false"
                            (ngModelChange)="queryFocusChanged()" [isDisabled]="isInFreeFormMode"
                            [automationId]="modalAutomationId + '-start-date-time-picker'">
                        </res-custom-date-time-picker>
                        <div class="picker-separator">~~</div>
                        <res-custom-date-time-picker class="date-time-picker" name="dateEnd" ngDefaultControl
                            [inputPlaceholder]="defaultDatePlaceholders[1]" (click)="onDateClick($event,'end')"
                            (focusout)="onFocusLost($event,'end')" [(ngModel)]="searchObject.endDate"
                            [isDateRange]="true" [hasErrorMessage]="dateError" [isStart]="false" [isEnd]="true"
                            (ngModelChange)="queryFocusChanged()" [isDisabled]="isInFreeFormMode"
                            [automationId]="modalAutomationId + '-end-date-time-picker'">
                        </res-custom-date-time-picker>
                        <div class="expand-date-range">
                            <res-custom-checkbox
                                [attr.data-automation-id]="modalAutomationId + '-expand-range-by-one-day'"
                                [(ngModel)]="searchObject.dateFilters.expandDateRange" [isDisabled]="isInFreeFormMode"
                                (ngModelChange)="queryFocusChanged()" [content]="'Expand range by 1 day'">
                            </res-custom-checkbox>
                        </div>
                    </div>
                    <div class="button-group-checkbox-control">
                        <div class="option-button-group">
                            <div class="modal-row">
                                <div class="modal-row-column-max">
                                    <ul class="inline-select">
                                        <li>
                                            <label for="all-doc-dates"
                                                [ngClass]="{'active': searchObject.dateFilters.dateRangeType == 'allDates', disabled: isInFreeFormMode}"
                                                [attr.data-automation-id]="modalAutomationId + '-all-doc-dates-button'">
                                                <input type="radio" name="dates-type" id="all-doc-dates"
                                                    [(ngModel)]="searchObject.dateFilters.dateRangeType"
                                                    value="allDates" [disabled]="isInFreeFormMode"
                                                    (ngModelChange)="searchObject.dateFilters.dateRangeTypeSet()" />
                                                All Doc Dates
                                            </label>
                                        </li>
                                        <li>
                                            <label for="parent-dates"
                                                [ngClass]="{'active': searchObject.dateFilters.dateRangeType == 'parentDates', disabled: isInFreeFormMode}"
                                                [attr.data-automation-id]="modalAutomationId + '-parent-dates-button'">
                                                <input type="radio" name="dates-type" id="parent-dates"
                                                    [(ngModel)]="searchObject.dateFilters.dateRangeType"
                                                    value="parentDates" [disabled]="isInFreeFormMode"
                                                    (ngModelChange)="searchObject.dateFilters.dateRangeTypeSet()" />
                                                Parent Dates
                                            </label>
                                        </li>
                                        <li>
                                            <label for="custom-dates"
                                                [ngClass]="{'active': searchObject.dateFilters.dateRangeType == 'customDates', disabled: isInFreeFormMode}"
                                                [attr.data-automation-id]="modalAutomationId + '-custom-dates-button'">
                                                <input type="radio" name="dates-type" id="custom-dates"
                                                    [(ngModel)]="searchObject.dateFilters.dateRangeType"
                                                    value="customDates" [disabled]="isInFreeFormMode"
                                                    (ngModelChange)="searchObject.dateFilters.dateRangeTypeSet()" />Custom
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="checkbox-container">
                            <div class="modal-row">
                                <div class="modal-row-column-auto">
                                    <div class="text-indicator">
                                        <p><span class="word-indicator"
                                                [ngClass]="{ disabled: isInFreeFormMode}">Email:</span></p>
                                    </div>
                                    <res-custom-checkbox name="sentDateAdv"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-send-email'"
                                        [(ngModel)]="searchObject.dateFilters.flags.sent"
                                        (ngModelChange)="queryFocusChanged()" content="Sent"></res-custom-checkbox>
                                    <res-custom-checkbox name="receivedDateAdv"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-received-email'"
                                        [(ngModel)]="searchObject.dateFilters.flags.received"
                                        (ngModelChange)="queryFocusChanged()" content="Received"></res-custom-checkbox>
                                </div>
                                <div class="modal-row-column-auto">
                                    <div class="text-indicator">
                                        <p><span class="word-indicator"
                                                [ngClass]="{ disabled: isInFreeFormMode}">Appointment:</span></p>
                                    </div>
                                    <res-custom-checkbox name="appointmentStarted"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-started-appointment'"
                                        [(ngModel)]="searchObject.dateFilters.flags.datestarted"
                                        (ngModelChange)="queryFocusChanged()" content="Started"></res-custom-checkbox>
                                    <res-custom-checkbox name="appointmentEnded"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-ended-appointment'"
                                        [(ngModel)]="searchObject.dateFilters.flags.dateended"
                                        (ngModelChange)="queryFocusChanged()" content="Ended"></res-custom-checkbox>
                                </div>
                                <div class="modal-row-column-auto">
                                    <div class="text-indicator">
                                        <p><span class="word-indicator"
                                                [ngClass]="{ disabled: isInFreeFormMode}">Embedded:</span></p>
                                    </div>
                                    <res-custom-checkbox name="embeddedAccessed"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-accessed-embedded'"
                                        [(ngModel)]="searchObject.dateFilters.flags.dateaccessed"
                                        (ngModelChange)="queryFocusChanged()" content="Accessed"></res-custom-checkbox>
                                    <res-custom-checkbox name="embeddedCreated"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-created-embedded'"
                                        [(ngModel)]="searchObject.dateFilters.flags.datecreated"
                                        (ngModelChange)="queryFocusChanged()" content="Created"></res-custom-checkbox>
                                    <res-custom-checkbox name="embeddedModified"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-modified-embedded'"
                                        [(ngModel)]="searchObject.dateFilters.flags.datemodified"
                                        (ngModelChange)="queryFocusChanged()" content="Modified"></res-custom-checkbox>
                                </div>
                                <div class="modal-row-column-auto">
                                    <div class="text-indicator">
                                        <p><span class="word-indicator" [ngClass]="{ disabled: isInFreeFormMode}">File
                                                System:</span></p>
                                    </div>
                                    <res-custom-checkbox name="systemAccessed"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-accessed-file-system'"
                                        [(ngModel)]="searchObject.dateFilters.flags.lastaccesstime"
                                        (ngModelChange)="queryFocusChanged()" content="Accessed"></res-custom-checkbox>
                                    <res-custom-checkbox name="systemCreated"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-created-file-system'"
                                        [(ngModel)]="searchObject.dateFilters.flags.createdtime"
                                        (ngModelChange)="queryFocusChanged()" content="Created"></res-custom-checkbox>
                                    <res-custom-checkbox name="systemModified"
                                        [disabled]="searchObject.dateFilters.dateRangeType != 'customDates' || isInFreeFormMode"
                                        [automationId]="modalAutomationId + '-modified-file-system'"
                                        [(ngModel)]="searchObject.dateFilters.flags.lastmodifiedtime"
                                        (ngModelChange)="queryFocusChanged()" content="Modified"></res-custom-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="checkbox-radio-controls">
                        <div class="modal-row">
                            <div class="modal-row-column-auto left-margin">
                                <res-custom-checkbox name="includeParentswoSend" [disabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-include-parent-wo-sent-received'"
                                    [(ngModel)]="searchObject.dateFilters.includeParentEmails"
                                    content="Include Parent Emails w/o Sent/Received"
                                    (ngModelChange)="queryFocusChanged();searchObject.dateFilters.useEmailCreatedDate = false">
                                </res-custom-checkbox>
                                <div class="checkbox-align-right">
                                    <res-custom-checkbox name="useEmailCreateDate"
                                        [disabled]="!searchObject.dateFilters.includeParentEmails || isInFreeFormMode"
                                        [(ngModel)]="searchObject.dateFilters.useEmailCreatedDate"
                                        [automationId]="modalAutomationId + '-use-email-created-date'"
                                        (ngModelChange)="queryFocusChanged()" content="Use Email Created Date">
                                    </res-custom-checkbox>
                                </div>
                            </div>
                            <div class="modal-row-column-auto">
                                <label [ngClass]="{ disabled: isInFreeFormMode}">Date Range Scope:</label>
                            </div>
                            <div class="modal-row-column-auto radio-column">
                                <res-custom-radio-button [automationId]="modalAutomationId + '-date-range-scope-family'"
                                    [(ngModel)]="searchObject.dateFilters.searchTermsType" content="Family"
                                    [isDisabled]="isInFreeFormMode" name="dateRangeScope" [value]="true"
                                    (ngModelChange)="queryFocusChanged()" [marginLeft]="10"></res-custom-radio-button>
                                <res-custom-radio-button
                                    [automationId]="modalAutomationId + '-date-range-scope-document'"
                                    [isDisabled]="isInFreeFormMode"
                                    [(ngModel)]="searchObject.dateFilters.searchTermsType" content="Document"
                                    name="dateRangeScope" [value]="false" (ngModelChange)="queryFocusChanged()"
                                    [marginLeft]="10"></res-custom-radio-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="middle-left-content">
                    <div class="panel-parent">
                        <!-- SENDERS/RECIPIENTS-->
                        <div class="left-settings-panel">
                            <div class="custom-panel-header">Senders/Recipients</div>
                        </div>
                        <div class="group-container">
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-panel">
                                    <p class="input-indicator">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> senders: </span>
                                    </p>
                                </div>
                                <res-custom-input [queryFocusChanged]="queryFocusChanged.bind(this)"
                                    [field]="searchObject.senders" [isFieldDisabled]="isInFreeFormMode"
                                    iconClass="fa-pencil-square-o" iconColor="color-blue-01"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'senders', 'senders', searchObject.senders)"
                                    [automationId]="modalAutomationId + '-sender-recipients-any-of-these-senders'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <select [(ngModel)]="filterByClause" (ngModelChange)="queryFocusChanged()"
                                    data-automation-id="advanced-search-filter-by-clause-input-option'"
                                    class="clause-dropdown" [disabled]="isInFreeFormMode">
                                    <option *ngFor="let clause of filterClause" [value]="clause.name">{{clause.name}}
                                    </option>
                                </select>
                                <div class="search-input-row-label-middle-custom-panel">
                                    <p class="input-indicator">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> recipients: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.recipients" [isFieldDisabled]="isInFreeFormMode"
                                    [queryFocusChanged]="queryFocusChanged.bind(this)" iconClass="fa-pencil-square-o"
                                    iconColor="color-blue-01"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'recipients', 'recipients', searchObject.recipients)"
                                    [automationId]="modalAutomationId + '-sender-recipients-any-of-these-recipients'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-panel">
                                    <p class="input-indicator">
                                        <span class="word-indicator">With </span>
                                        <span class="phrase-indicator"> subject:</span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.subject" [isFieldDisabled]="isInFreeFormMode"
                                    [queryFocusChanged]="queryFocusChanged.bind(this)"
                                    [automationId]="modalAutomationId + '-sender-recipients-with-subject'">
                                </res-custom-input>
                            </div>
                        </div>
                        <!-- END SENDER/RECIPIENTS-->

                        <!-- TAGS-->
                        <div class="left-settings-panel" *ngIf="hasTagsPermission">
                            <div class="custom-panel-header">Tags</div>
                        </div>
                        <div class="group-container" *ngIf="hasTagsPermission">
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-tags-custodian-folder-panel">
                                    <p class="input-indicator">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these tags:</span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.oneOrMoreTags"
                                    [isFieldDisabled]="isTCFDisabled || isInFreeFormMode"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'tags', 'oneOrMoreTags', searchObject.oneOrMoreTags)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.oneOrMoreTags)"
                                    iconClass="fa-tags" iconColor="color-grey-09"
                                    [automationId]="modalAutomationId + '-tags-one-or-more-tags'"></res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-tags-custodian-folder-panel">
                                    <p class="input-indicator">
                                        <span class="all-indicator">ALL</span>
                                        <span class="word-indicator"> of these tags:</span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.allTags"
                                    [isFieldDisabled]="isTCFDisabled || isInFreeFormMode"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'tags', 'allTags', searchObject.allTags)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.allTags)"
                                    iconClass="fa-tags" iconColor="color-grey-09"
                                    [automationId]="modalAutomationId + '-tags-all-tags'"></res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-tags-custodian-folder-panel">
                                    <p class="input-indicator">
                                        <span class="none-indicator">NONE</span>
                                        <span class="word-indicator"> of these tags:</span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.noneTags"
                                    [isFieldDisabled]="isTCFDisabled || isInFreeFormMode"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'tags', 'noneTags', searchObject.noneTags)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.noneTags)"
                                    iconClass="fa-tags" iconColor="color-grey-09"
                                    [automationId]="modalAutomationId + '-tags-none-tags'"></res-custom-input>
                            </div>
                        </div>
                        <!-- END TAGS-->

                        <!-- CUSTODIANS-->
                        <div class="left-settings-panel" *ngIf="hasCustodiansPermissions">
                            <div class="custom-panel-header">Custodians</div>
                        </div>
                        <div class="group-container" *ngIf="hasCustodiansPermissions">
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-tags-custodian-folder-panel">
                                    <p class="input-indicator">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these custodians:</span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.anyCustodians"
                                    [isFieldDisabled]="isTCFDisabled || isInFreeFormMode"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'custodians', 'anyCustodians', searchObject.anyCustodians)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.anyCustodians)"
                                    iconClass="fa-user-circle" iconColor="color-blue-01"
                                    [automationId]="modalAutomationId + '-custodians-one-or-more-custodians'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-tags-custodian-folder-panel">
                                    <p class="input-indicator">
                                        <span class="none-indicator">NONE</span>
                                        <span class="word-indicator"> of these custodians:</span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.noneCustodians"
                                    [isFieldDisabled]="isTCFDisabled || isInFreeFormMode"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'custodians', 'noneCustodians', searchObject.noneCustodians)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.noneCustodians)"
                                    iconClass="fa-user-circle" iconColor="color-blue-01"
                                    [automationId]="modalAutomationId + '-custodians-none-custodians'">
                                </res-custom-input>
                            </div>
                        </div>
                        <!-- END CUSTODIANS-->

                        <!-- FOLDERS-->
                        <div class="left-settings-panel" *ngIf="hasFoldersPermissions">
                            <div class="custom-panel-header">Folders</div>
                        </div>
                        <div class="group-container" *ngIf="hasFoldersPermissions">
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-tags-custodian-folder-panel">
                                    <p class="input-indicator">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these folders:</span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.anyFolders"
                                    [isFieldDisabled]="isTCFDisabled || isInFreeFormMode"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'folders', 'anyFolders', searchObject.anyFolders)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.anyFolders)"
                                    iconClass="fa-folder" iconColor="color-yellow-07"
                                    [automationId]="modalAutomationId + '-folders-one-or-more-folders'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-tags-custodian-folder-panel">
                                    <p class="input-indicator">
                                        <span class="none-indicator">NONE</span>
                                        <span class="word-indicator"> of these folders:</span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.noneFolders"
                                    [isFieldDisabled]="isTCFDisabled || isInFreeFormMode"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'folders', 'noneFolders', searchObject.noneFolders)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.noneFolders)"
                                    iconClass="fa-folder" iconColor="color-yellow-07"
                                    [automationId]="modalAutomationId + '-folders-none-folders'"></res-custom-input>
                            </div>
                        </div>
                        <!-- END FOLDERS-->
                    </div>
                </div>
                <div class="middle-right-content no-border">
                    <div class="panel-parent">
                        <!-- DOMAINS-->
                        <div class="left-settings-panel">
                            <div class="custom-panel-header">Domain Lists</div>
                        </div>
                        <div class="group-container">
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> senders: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.senderDomains"
                                    [isFieldDisabled]="isInFreeFormMode"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'domains', 'senderDomains', searchObject.senderDomains)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.senderDomains)"
                                    iconClass="fa-at" iconColor="color-grey-10"
                                    [automationId]="modalAutomationId + '-sender-domains-any-of-these-senders'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="none-indicator">NONE</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> senders: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.senderDomainsNone"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'domains', 'senderDomainsNone', searchObject.senderDomainsNone)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.senderDomainsNone)"
                                    iconClass="fa-at" iconColor="color-grey-10" [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-sender-domains-none-of-these-senders'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <select [(ngModel)]="domainRecipientsFilterClause" (ngModelChange)="queryFocusChanged()"
                                    data-automation-id="advanced-search-domain-recipients-filter-by-clause-input-option'"
                                    class="clause-dropdown" [disabled]="isInFreeFormMode">
                                    <option *ngFor="let clause of filterClause" [value]="clause.name">{{clause.name}}
                                    </option>
                                </select>
                                <div class="search-input-row-label-middle-right-panel has-left-dropdown">
                                    <p class="input-indicator wide">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> recipients: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.recipientDomains"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'domains', 'recipientDomains', searchObject.recipientDomains)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.recipientDomains)"
                                    iconClass="fa-at" iconColor="color-grey-10" [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-recipient-domains-any-of-these-recipients'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="none-indicator">NONE</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> recipients: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.recipientDomainsNone"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'domains', 'recipientDomainsNone', searchObject.recipientDomainsNone)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.recipientDomainsNone)"
                                    iconClass="fa-at" iconColor="color-grey-10" [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-recipient-domains-none-of-these-recipients'">
                                </res-custom-input>
                            </div>
                        </div>
                        <!-- END DOMAINS-->

                        <!-- ALIAS LISTS-->
                        <div class="left-settings-panel">
                            <div class="custom-panel-header">Alias Lists</div>
                        </div>
                        <div class="group-container">
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> senders: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.anySenderAliases"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'alias-list', 'anySenderAliases', searchObject.anySenderAliases)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.anySenderAliases)"
                                    iconClass="fa-address-book-o" iconColor="color-blue-01"
                                    [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-alias-list-any-sender-aliases'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="none-indicator">NONE</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> senders: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.noneSenderAliases"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'alias-list', 'noneSenderAliases', searchObject.noneSenderAliases)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.noneSenderAliases)"
                                    iconClass="fa-address-book-o" iconColor="color-blue-01"
                                    [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-alias-list-none-sender-aliases'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> recipients: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.anyRecipientAliases"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'alias-list', 'anyRecipientAliases', searchObject.anyRecipientAliases)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this,searchObject.anyRecipientAliases)"
                                    iconClass="fa-address-book-o" iconColor="color-blue-01"
                                    [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-alias-list-any-recipient-aliases'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="none-indicator">NONE</span>
                                        <span class="word-indicator"> of these</span>
                                        <span class="phrase-indicator"> recipients: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.noneRecipientAliases"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'alias-list', 'noneRecipientAliases', searchObject.noneRecipientAliases)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.noneRecipientAliases)"
                                    iconClass="fa-address-book-o" iconColor="color-blue-01"
                                    [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-alias-list-none-recipient-aliases'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="any-indicator">ANY</span>
                                        <span class="word-indicator"> of these in</span>
                                        <span class="phrase-indicator"> document content: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.anyDocumentAliases"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'alias-list', 'anyDocumentAliases', searchObject.anyDocumentAliases)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this, searchObject.anyDocumentAliases)"
                                    iconClass="fa-address-book-o" iconColor="color-blue-01"
                                    [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-alias-list-any-document-aliases'">
                                </res-custom-input>
                            </div>
                            <div class="search-input-row">
                                <div class="search-input-row-label-middle-right-panel">
                                    <p class="input-indicator wide">
                                        <span class="none-indicator">NONE</span>
                                        <span class="word-indicator"> of these in</span>
                                        <span class="phrase-indicator"> document content: </span>
                                    </p>
                                </div>
                                <res-custom-input [field]="searchObject.noneDocumentAliases"
                                    [openTargetPicker]="openTargetPicker.bind(this, 'alias-list', 'noneDocumentAliases', searchObject.noneDocumentAliases)"
                                    [queryFocusChanged]="queryFocusChanged.bind(this,searchObject.noneDocumentAliases)"
                                    iconClass="fa-address-book-o" iconColor="color-blue-01"
                                    [isFieldDisabled]="isInFreeFormMode"
                                    [automationId]="modalAutomationId + '-alias-list-none-document-aliases'">
                                </res-custom-input>
                            </div>
                        </div>
                        <!-- END ALIAS LISTS-->
                    </div>
                </div>
            </div>
            <div class="metadata-filters" data-automation-id="additional-metadata-filter-container">
                <!-- METADATA FILTERS-->
                <div class="custom-panel-header metadata-panel-header">
                    <span>Additional Metadata Filters</span>
                    <button data-automation-id="dr-metadata-reference-help-button" type="button" class="btn btn-link"
                        (click)="openHelp()">
                        <span>DR Metadata Reference ...</span> </button>
                </div>
                <div class="metadata-filters-content">
                    <div class="metadata-filters-any">
                        <div class="group-container">
                            <div class="group-text">
                                <p class="input-indicator wide">
                                    <span class="any-indicator">ANY</span>
                                    <span class="word-indicator"> of these:</span>
                                </p>
                                <button type="button" class="remove-row transparent-button"
                                    [disabled]="objectNameValue.metadataFilterAnyList?.length === 1 || isInFreeFormMode"
                                    (click)="removeAllFromAnyList()" data-automation-id="any-of-these-delete-button">
                                    <i class="fa fa-trash" data-automation-id="any-of-these-delete-icon"></i>
                                </button>
                            </div>
                            <res-metadata-filters #metadataFilterAny [rows]="objectNameValue.metadataFilterAnyList"
                                [queryColumnHidden]="false" [removeBoarders]="false"
                                [isInFreeFormMode]="isInFreeFormMode" [automationId]="'any-of-these'"
                                [validateName]="false" [metadataProperties]="metadataProperties"
                                [onDataSourceChanged]="parseMetadataFilters.bind(this,'any')"
                                (openPickerEmmiter)="openMetadataPicker($event, 'any')">
                            </res-metadata-filters>

                        </div>
                    </div>
                    <div class="metadata-filters-all">
                        <div class="group-container">
                            <div class="group-text">
                                <p class="input-indicator wide">
                                    <span class="all-indicator">AND ALL</span>
                                    <span class="word-indicator"> of these:</span>
                                </p>
                                <button type="button" class="remove-row transparent-button"
                                    [disabled]="objectNameValue.metadataFilterAllList?.length === 1 || isInFreeFormMode"
                                    (click)="removeAllFromAllList()"
                                    data-automation-id="and-all-of-these-delete-button">
                                    <i class="fa fa-trash" data-automation-id="and-all-of-these-delete-icon"></i>
                                </button>
                            </div>
                            <res-metadata-filters [rows]="objectNameValue.metadataFilterAllList"
                                [queryColumnHidden]="false" [removeBoarders]="false" #metadataFilterAll
                                [metadataProperties]="metadataProperties" [automationId]="'and-all-of-these'"
                                [validateName]="false" [metadataProperties]="metadataProperties"
                                [onDataSourceChanged]="parseMetadataFilters.bind(this,'all')"
                                [isInFreeFormMode]="isInFreeFormMode"
                                (openPickerEmmiter)="openMetadataPicker($event, 'all')">
                            </res-metadata-filters>
                        </div>
                    </div>
                    <div class="metadata-filters-none">
                        <div class="group-container">
                            <div class="group-text">
                                <p class="input-indicator wide">
                                    <span class="all-indicator">AND</span>
                                    <span class="none-indicator"> NONE</span>
                                    <span class="word-indicator"> of these:</span>
                                </p>
                                <button type="button" class="remove-row transparent-button"
                                    [disabled]="objectNameValue.metadataFilterNoneList?.length === 1 || isInFreeFormMode"
                                    (click)="removeAllFromNoneList()"
                                    data-automation-id="and-none-of-these-delete-button">
                                    <i class="fa fa-trash" data-automation-id="and-none-of-these-delete-button"></i>
                                </button>
                            </div>
                            <res-metadata-filters [rows]="objectNameValue.metadataFilterNoneList"
                                [queryColumnHidden]="false" [removeBoarders]="false" #metadataFilterNone
                                [isInFreeFormMode]="isInFreeFormMode" [automationId]="'and-none-of-these'"
                                [validateName]="false" [metadataProperties]="metadataProperties"
                                [onDataSourceChanged]="parseMetadataFilters.bind(this,'none')"
                                (openPickerEmmiter)="openMetadataPicker($event, 'none')">
                            </res-metadata-filters>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <res-resizer anchor="bottom" ellipsisExpander="true" resizingElementId="queryPanel"
            secondElementId="searchPanel" [collapsible]="false" [initSize]="110" [minSize]="110">
        </res-resizer>

        <div class="advanced-search-query-content" id="queryPanel">
            <button class="clear-btn" [hidden]="!(freeForm.query && freeForm.query.trim())"
                [ngClass]="[checkFreeformScroll() ? 'clear-button-scroll' : '']" (click)="clearQueryClicked()"
                [automationId]="modalAutomationId + '-query-clear-button'">
                <i class="fa fa-times"></i>
            </button>
            <div class="query-container" [ngClass]="{'query-container-edit-mode': isInFreeFormMode}"
                id="queryOutputPanel">
                <res-generic-input #freeformInput [queryString]="queryString" [colorizeOnQueryChange]="false"
                    [inputChangedEvent]="inputChanged.bind(this)" [keyPressEvent]="keyPressEvent.bind(this)"
                    [automationId]="'advanced-search'" [isAdvanceSearchFromWorkFlow]="isAdvanceSearchFromWorkFlow">
                </res-generic-input>
            </div>
        </div>
    </div>
    <ng-template #buttonTemplate>
        <button type="button" [attr.data-automation-id]="modalAutomationId + '-discard-freeform-changes-button'"
            class="secondary-button freeform-edit-left " (click)="discardFreeformChanges()"
            [disabled]="disableDiscardButton">
            <i class="fa fa-undo color-blue-01"></i>Discard Freeform Changes
        </button>
    </ng-template>

</res-base-modal>